import { getProductsBySkuListWithAvailability } from '../Products/selector'

export default (
  state = {
    itemToItem: { products: [], isLoading: false },
    user: { products: [], isLoading: false }
  },
  action
) => {
  switch (action.type) {
    case 'FETCH_USER_RECOMENDATION':
      return {
        ...state,
        user: { products: [], isLoading: true }
      }
    case 'FETCH_ITEM_TO_ITEM__RECOMENDATION':
      return {
        ...state,
        itemToItem: { products: [], isLoading: true }
      }

    case 'FETCH_USER_RECOMENDATION_SUCCESS':
      return {
        ...state,
        user: { products: [...action.payload.data], isLoading: false }
      }

    case 'FETCH_ITEM_TO_ITEM__RECOMENDATION_SUCCESS':
      return {
        ...state,
        itemToItem: { products: [...action.payload.data], isLoading: false }
      }

    case 'FETCH_USER_RECOMENDATION_FAIL':
      return { ...state, error: action.error }

    case 'FETCH_ITEM_TO_ITEM__RECOMENDATION_FAIL':
      return { ...state, error: action.error }

    case 'FETCH_RECOMENDATION_CARD_AVAILABILITY':
      return { ...state }
    case 'FETCH_RECOMENDATION_CARD_AVAILABILITY_SUCCESS':
      const availability = action.payload.data[0]

      const { products } = state
      const {
        meta: {
          previousAction: { sku }
        }
      } = action

      const index = products.findIndex(p => p.sku === sku)

      if (products[index]) {
        products[index].availability = { ...availability }
      }

      return { ...state, products }
    case 'FETCH_RECOMENDATION_CARD_AVAILABILITY_FAIL':
      return { ...state, error_availability: action.error }
    default:
      return { ...state }
  }
}

const getRandomInt = (min, max) => {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min + 1)) + min
}

export const getUserRecomendation = (
  listProducts,
  recomendation,
  availabilities
) => {
  const {
    user: { products }
  } = recomendation

  const productsRecomendation =
    products.length > 0
      ? getProductsBySkuListWithAvailability(
        listProducts,
        products,
        availabilities
      )
      : products

  productsRecomendation.forEach(item => {
    if (item.availability) {
      item.availability['onlyCash'] = {
        sellingPrice: getRandomInt(0, 1000).toFixed(2)
      }
    }
  })

  const voucher = {
    products:
      products.length > 0
        ? getProductsBySkuListWithAvailability(
          listProducts,
          products,
          availabilities
        )
        : products,
    title: 'Veja os produtos indicados para você',
    titleMobile: 'Produtos'
  }

  return voucher
}

export const getItemToItemRecomendation = (
  listProducts,
  recomendation
) => {
  const {
    itemToItem: { products }
  } = recomendation

  const productsRecomendation =
    products.length > 0
      ? getProductsBySkuListWithAvailability(
        listProducts,
        products
      )
      : products

  productsRecomendation.forEach(item => {
    if (item.availability) {
      item.availability['onlyCash'] = {
        sellingPrice: getRandomInt(0, 1200).toFixed(2)
      }
    }
  })

  const voucher = {
    products:
      products.length > 0
        ? getProductsBySkuListWithAvailability(
          listProducts,
          products
        )
        : products,
    title: 'Veja os produtos indicados para você',
    titleMobile: 'Produtos'
  }

  return voucher
}



// WEBPACK FOOTER //
// ./src/features/Recomendation/reducer.js